




























const namespace = 'calendar';
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import GenericForm from '@/modules/form/components/GenericForm.vue';
import ICalendarData from '@/modules/calendar/interfaces/ICalendarData';
import { configuration } from '@/modules/configuration/store';
import { Environment } from '@/modules/configuration/store/types';

@Component({
    name: 'SubscribeButton',
    components: {
        GenericForm,
    },
})
export default class SubscribeButton extends Vue {
    @Prop() public event!: ICalendarData;
    @Prop() public dialogOpened!: boolean;
    @Getter('weekdaysContainerWidth', { namespace }) private weekdaysContainerWidth!: number;
    @Getter('environment', { namespace: 'configuration' }) private environment!: Environment;
    private dialog = false;

    private close() {
        this.dialog = false;
    }

    private open() {
        this.dialog = true;
    }

    private get isZoukWroclove() {
        return ['zoukwroclove', 'dev', 'uat'].includes(this.environment.name);
    }

    private goToSubscribePage() {
        const subscribeLink =
            window.location.origin + (window.location.pathname.includes('/pl/') ? '/pl/zapisy/' : '/en/sign-in/');
        window.open(subscribeLink);
    }

    private subscribe() {
        this.$route.query.e = this.event.Id.toString();
    }

    protected mounted() {
        this.dialog = this.dialogOpened;
    }
}
